/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_Messageplaceholder1Inputs */

const he_contact_form_messageplaceholder1 = /** @type {(inputs: Contact_Form_Messageplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`כתוב את הודעתך כאן...`)
};

const en_contact_form_messageplaceholder1 = /** @type {(inputs: Contact_Form_Messageplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write your message here...`)
};

/**
* | output |
* | --- |
* | "Write your message here..." |
*
* @param {Contact_Form_Messageplaceholder1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const contact_form_messageplaceholder1 = /** @type {((inputs?: Contact_Form_Messageplaceholder1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_Messageplaceholder1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_contact_form_messageplaceholder1(inputs)
	return en_contact_form_messageplaceholder1(inputs)
});
export { contact_form_messageplaceholder1 as "contact_form_messagePlaceholder" }